import { Component, OnInit ,ElementRef, ViewChild} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Activities } from 'src/interfaces/activities';
import { AppservicesService } from '../services/appservices.service';
import {FormBuilder,FormControl,FormGroup,Validators } from '@angular/forms';
import { Company } from 'src/interfaces/company';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { number } from 'echarts';

@Component({
  selector: 'app-newcompany',
  templateUrl: './newcompany.component.html',
  styleUrls: ['./newcompany.component.scss'],
})
export class NewcompanyComponent implements OnInit {

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  
  activities:Activities[]=[];
  showgoodname:boolean=false;
  showbadname:boolean=false;
  newcompany:Company;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl =  this.formbuilder.group({
    id:number,
    name:[''],
    description: [''],
    types:['']
  });
  filteredFruits: Observable<Activities[]>;
  fruits: Activities[] = [];
  allFruits: Activities[] = [];


  constructor(public formbuilder:FormBuilder,private appserv:AppservicesService, private modal:ModalController)
     {
      this.allFruits=this.appserv.getactivities();
      this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit) => (fruit ? this._filter(fruit) : this.allFruits.slice())),
      )
     }

  form = this.formbuilder.group({
    name:['', [Validators.required]],
    description: ['', [Validators.required]],
    types:[[], [Validators.required]]
  });

  ngOnInit() {
    this.activities=this.appserv.getactivities();
  }

  
  add(event: MatChipInputEvent): void {
    const value = (event.value);

    // Add our fruit
    if (value) {
      this.fruits.push();
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: Activities): void {

    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  selected($event:MatAutocompleteSelectedEvent): void {
   
    const fruit=$event.option.value;

    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      
    }else{
      this.fruits.push($event.option.value);
      this.fruitInput.nativeElement.value = '';
    }
   
  }

  private _filter(value: any): Activities[] {
    const filterValue = value;

    return this.allFruits.filter(fruit => fruit.id==filterValue.id);
  }

  async closemodal(){
    this.modal.dismiss();
  }

  async createcompany(){

    if(this.form.get('name').value){

      const companies=this.appserv.companyiesdata().filter(c=>c.name.toLocaleLowerCase()==this.form.get('name').value.toLocaleLowerCase());

      if(companies.length>0){
        this.showbadname=true;
        this.appserv.presentToast('ce nom existe deja','warning');
      }else{
        this.newcompany=this.form.value;
        this.showgoodname=true;
        this.appserv.presentToast('Entreprise créée avec succès.','success');
        this.form.reset();
        console.log(this.fruits)
        //this.appserv.closemodal();
      }
    }else{
      this.appserv.presentToast('Veuillez completer le nom svp.','danger');
    }
  }

}
